/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ConfigurationTemplatePriceCalculationActor {
    All = 0,
    Organisation = 1,
    Customer = 2,
}
